import MediaObject from './MediaObject'

export default MediaObject



// WEBPACK FOOTER //
// ./src/components/MediaObject/index.js